import type ru from '@/i18n/locales/ru'

/**
 * Узбекский (латиница) — как в макете и в веб-версии.
 * Тип берём из русской локали: пропущенный ключ станет ошибкой сборки,
 * а не молчаливым русским текстом посреди узбекского экрана.
 */
const uz: typeof ru = {
  common: {
    next: 'Keyingisi',
    save: 'Saqlash',
    confirm: 'Tasdiqlash',
    yes: 'Ha',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    close: 'Yopish',
    back: 'Orqaga',
    clear: 'Tozalash',
    send: 'Yuborish',
    apply: "Qo'llash",
    choose: 'Tanlash',
    done: 'Tayyor',
    expand: 'Ochish',
    less: 'Kamroq',
    more: "Ko'proq",
    map: 'Xarita',
    total: 'Jami',
    calculation: 'Hisob',
    sum: "so'm",
  },

  nav: {
    home: 'Asosiy',
    menu: 'Menyu',
    cart: 'Savat',
    orders: 'Buyurtmalar',
    profile: 'Profil',
  },

  units: {
    ml: 'ml',
    g: 'g',
    kcal: 'kkal',
    protein: 'oqsillar',
    fat: 'yog\'lar',
    carbs: 'uglevodlar',
    per100: '100 g uchun',
    min: 'daq',
  },

  delivery: {
    delivery: 'Yetkazib berish',
    pickup: 'Olib ketish',
    takeaway: 'Olib ketaman',
    free: 'Bepul',
  },

  toast: {
    success: 'Tayyor',
    error: 'Xatolik',
    warning: 'Diqqat',
    info: "Ma'lumot",
  },

  errors: {
    unknown: "Noma'lum xatolik",
    timeout: 'Kutish vaqti tugadi',
    offline: "Server bilan aloqa yo'q",
    request: "So'rov xatosi",
    captchaUnavailable: 'Kapcha ishlamayapti',
    captchaFailed: 'reCAPTCHA yuklanmadi',
    geoDenied:
      "Joylashuvga ruxsat berilmagan — sozlamalarda yoqing yoki nuqtani qo'lda belgilang",
    geoFailed: "Joylashuvni aniqlab bo'lmadi — nuqtani qo'lda belgilang",
    geoDeniedMap:
      'Joylashuvga ruxsat berilmagan — sozlamalarda yoqing yoki manzilni xaritada belgilang',
    geoSkipped: 'Joylashuvsiz ham boladi — manzilni xaritada belgilang',
    pointNotFound: "Manzil bo'yicha nuqta topilmadi — uni xaritada belgilang",
    pointRequired: 'Xaritada nuqtani belgilang',
  },

  onboarding: {
    languageTitle: 'Tilni tanlang',
    orderTypeTitle: 'Buyurtma turi',
    introTitle: "Bir necha daqiqada buyurtma —\nto'g'ridan-to'g'ri Telegramda",
    geoTitle: 'Qayerdasiz?',
    geoText:
      'Shaharni aniqlaymiz — menyu, narxlar va eng yaqin restoranni ko\'rsatamiz. Ularsiz bo\'lmaydi:\nturli shaharlarda ular farq qiladi.',
    geoAction: 'Joylashuvga ruxsat berish',
    searchingTitle: 'Bir daqiqa...',
    searchingText: 'Sizni xaritadan va eng yaqin\nrestorandan qidiryapmiz',
    addressPlaceholder: 'Manzilni kiriting',
  },

  auth: {
    signUp: "Ro'yxatdan o'tish",
    signIn: 'Kirish',
    phoneTitle: 'Raqamingiz',
    phoneLabel: 'Telefon raqami',
    telegramShare: 'Telegram orqali ulashish',
    codeTitle: 'Kodni kiriting',
    codeHint: 'Tasdiqlash kodi bilan SMS yubordik',
    codeResend: 'Kodni qayta yuborish',
    codeSent: 'Xabar telefon raqamingizga yuborildi',
    signedIn: 'Tizimga kirdingiz',
  },

  home: {
    bannerProductMissing: "Bu mahsulot hozir filialingiz menyusida yo'q",
    addressLabel: 'Yetkazib berish manzili',
    addressEmpty: 'Manzilni belgilang',
    branchEmpty: 'Filialni tanlang',
    searchPlaceholder: 'lavash, doner, pepsi...',
    hits: 'Hafta hitlari',
    novelties: 'Yangiliklar',
  },

  menu: {
    notFound: 'Hech narsa topilmadi',
    unavailable: 'Menyu mavjud emas',
    tryAnotherQuery: "So'rovni o'zgartirib ko'ring",
    tryAnotherAddress: 'Boshqa manzilni tanlang yoki sahifani yangilang',
  },

  product: {
    add: "Qo'shish",
    composition: 'Tarkibi',
    extraModifiers: "Qo'shimcha modifikatorlar",
    without: "{name}siz",
    upsell: 'Bu bilan tez-tez olishadi',
    addMore: "Yana {count} ta qo'shing",
    removeSome: '{count} ta olib tashlang',
    addToCart: "Savatga qo'shish",
    removeFromCart: 'Savatdan olib tashlash',
    addToFavorites: "Sevimlilarga qo'shish",
    removeFromFavorites: 'Sevimlilardan olib tashlash',
  },

  cart: {
    offerNow: 'faqat hozir',
    offerAdd: '{sum} ga qo\'shish',
    offerSkip: 'Rahmat, kerak emas',
    title: 'Savat',
    cutlery: 'Asboblar',
    items: 'mahsulot | mahsulot | mahsulot',
    upsell: 'Bu bilan tez-tez olishadi',
    empty: "Savat bo'sh",
    emptyText: "Menyudan biror narsa qo'shing",
    checkout: 'Buyurtma berish',
    discount: 'Chegirma',
  },

  checkout: {
    title: 'Buyurtmani rasmiylashtirish',
    submit: 'Rasmiylashtirish',
    branch: 'Filial',
    branchEmpty: 'Filial tanlanmagan',
    payment: "To'lov",
    recipient: 'Qabul qiluvchi',
    recipientSelf: "O'zimga",
    recipientOther: 'Boshqaga',
    recipientTo: 'Kimga yetkazamiz',
    nameRequired: 'Ismni kiriting',
    addressLabel: 'Yetkazib berish manzili',
    addressEmpty: 'Manzilni belgilang',
    entrance: "Kirish eshigi",
    floor: 'Qavat',
    flat: 'Xonadon/Ofis',
    addressComment: 'Manzil tafsilotlari',
    firstName: 'Ism',
    lastName: 'Familiya',
    phone: 'Telefon raqami',
    products: 'Mahsulotlar',
    promo: 'Promokod',
    promoDiscount: "Promokod bo'yicha",
    deliveryDiscount: "Yetkazishga chegirma",
    promoTitle: 'Sizning promokodlaringiz',
    promoPlaceholder: 'Promokodni kiriting',
    promoInvalid: 'Promokod bu buyurtmaga mos kelmadi',
    pointsSpend: 'Ballarni ishlatish',
    pointsRate: "1 ball = 1 so'm",
    pointsWithdraw: 'Ballardan yechamiz',
    successTitle: 'Buyurtma uchun rahmat!',
    successNumber: 'Buyurtma raqami:',
    successText: 'Operator qo\'ng\'irog\'ini kutish shart emas — yangiliklar bo\'lsa xabar beramiz.',
    successPay: 'Buyurtmani to\'lash',
    successTrack: 'Buyurtmani kuzatish',
    successTrackNumber: 'Buyurtma {number} • kuzatish',
    successHome: 'Asosiyga',
  },

  orders: {
    free: 'Bepul',
    discount: 'Chegirma',
    title: 'Buyurtmalar tarixi',
    tabActive: 'Faol',
    tabDone: 'Yakunlangan',
    emptyActive: 'Faol buyurtmalar yo\'q',
    emptyDone: "Hozircha bo'sh",
    emptyText: "Rasmiylashtirilgan buyurtmalar shu ro'yxatda ko'rinadi",
    order: 'Buyurtma',
    repeat: 'Takrorlash',
    repeatMissing: "Bu mahsulotlar hozir menyuda yo'q: {items}",
    track: 'Kuzatish',
    yourOrder: 'Sizning buyurtmangiz',
    notFound: 'Buyurtma topilmadi',
    support: "Qo'llab-quvvatlash bilan bog'lanish",
    noName: 'Ismsiz',
    address: 'Manzil',
    canceled: 'Buyurtma bekor qilindi',
    cancel: 'Buyurtmani bekor qilish',
    refund: 'Qabul qilgandan keyin qaytaramiz',
    courierChat: 'Kuryerga yozish',
    courierCall: "Kuryerga qo'ng'iroq qilish",
    route: 'Marshrut tuzish',
    rateTitle: "Buyurtmangiz qanday o'tdi?",
    rateText: 'Buyurtmani baholang. Bu bizga yaxshilanishga yordam beradi.',
    rateStar: 'Baho {star}',
  },

  status: {
    accepted: 'Qabul qilindi',
    acceptedText: 'Restoran buyurtmani tasdiqladi.',
    acceptedPickupText: "Buyurtmangizni oldik va oshxonaga\nuzatdik.",
    cooking: 'Tayyorlanmoqda',
    cookingText: "Oshpazlar tayyorlashmoqda — ozgina qoldi.",
    cookingPickupText: 'Buyurtmangizni tayyorlayapmiz. Ozgina qoldi.',
    onWay: "Kuryer yo'lda",
    onWayText: 'Kuryer buyurtmani oldi va sizga yetib kelmoqda.',
    near: "Kuryer yaqin",
    nearText: "Men yaqinman, 5 daqiqada yetib boraman!",
    delivered: 'Buyurtma yetkazildi',
    deliveredText: 'Yoqimli ishtaha! Ballar hisoblandi.',
    ready: 'Olib ketish mumkin',
    readyText: 'Buyurtma tayyor. Restoranda kutamiz.',
  },

  profile: {
    title: 'Profil',
    myData: "Ma'lumotlarim",
    language: 'Til',
    support: "Qo'llab-quvvatlash",
    feedback: 'Aloqa',
    supportContacts: 'Chat-bot yoki 78 150 00 30',
    addName: "Ism qo'shing",
    noPhone: "Raqam ko'rsatilmagan",
    edit: 'Profilni tahrirlash',
    addPhoto: "Rasm qo'shish",
    logout: 'Hisobdan chiqish',
    logoutConfirm: 'Hisobdan chiqasizmi?',
    logoutAction: 'Chiqish',
    photoTitle: "Rasm qo'shish",
    photoCamera: 'Kamera',
    photoGallery: 'Galereya',
    photoFailed: "Fotosuratni o'qib bo'lmadi",
  },

  settings: {
    title: 'Sozlamalar',
    personal: "Shaxsiy ma'lumotlar",
    avatarTitle: 'Avatarni tanlang',
    phone: 'Telefon raqami',
    firstName: 'Ism',
    lastName: 'Familiya',
    email: 'Elektron pochta',
    birthday: "Tug'ilgan sana",
    birthdayEmpty: 'Sanani tanlang',
    genderTitle: 'Jinsni tanlang',
    male: 'Erkak',
    female: 'Ayol',
    saved: "Ma'lumotlar saqlandi",
  },

  points: {
    unit: 'ball',
    heroTitle: 'Ballar\nsizni kutmoqda',
    balance: 'Balansingiz',
    howTitle: 'Ballar qanday ishlaydi',
    ruleEarn: "Mahsulotlar narxining 5% ini ballar bilan qaytaramiz — buyurtmani olganingizdan so'ng darhol. Aksiyalarda keshbek yuqoriroq bo'ladi.",
    ruleSpend:
      "1 ball = 1 so'm. Mahsulotlarni deyarli to'liq ballar bilan to'lang — kamida 1 000 so'm pul bilan to'lanadi. Yetkazib berishga ballar amal qilmaydi.",
    ruleExpiry: "Ballar 3 oy amal qiladi. Kuya boshlasa — 7 kun oldin Telegramda eslatamiz.",
    ruleProlong: "Har bir yangi buyurtma barcha ballar muddatini yana 3 oyga uzaytiradi. Buyurtma qiling — hech narsa kuymaydi.",
    historyTitle: 'Tarix',
    historyEmpty: "Bu yerda ballar hisoblanishi va sarflanishi paydo bo'ladi",
  },

  promo: {
    title: 'Mening promokodlarim',
    available: 'Mavjud promokodlar',
    empty: "Hozircha promokodlar yo'q",
    emptyText: "Aksiyalarni kuzating — promokodlaringiz shu yerda paydo bo'ladi",
    copy: 'Kodni nusxalash',
    copied: 'Promokod nusxalandi',
    copyFailed: "Kodni nusxalab bo'lmadi",
    until: '{date} gacha',
    freeDelivery: 'Bepul yetkazib berish',
    gift: 'Buyurtmaga sovg\'a',
    orderDiscount: 'Buyurtmaga chegirma',
    percentOff: 'Buyurtmaga {percent}% chegirma',
    amountOff: '{amount} chegirma',
    minOrder: '{amount} dan',
    itemsDiscount: 'Ayrim mahsulotlarga chegirma',
  },

  promotion: {
    deliveryLeft: 'bepul yetkazib berishgacha',
    deliveryDone: 'bepul yetkazib berish sizniki',
    bonusLeft: 'bepul bonusgacha',
    bonusDone: 'bonus sizniki',
    allDone: "Barcha bonuslar olindi!",
  },

  favorites: {
    title: 'Sevimlilar',
    subtitle: 'Sevimli taomlar',
    empty: "Hozircha bo'sh",
    emptyText:
      "Sevimli mahsulotlarni qo'shing — ularni tez topib, qayta buyurtma qilish oson bo'ladi",
    clearConfirm: 'Sevimlilar tozalansinmi?',
  },

  cards: {
    title: 'Kartalar',
    mine: 'Mening kartalarim',
    empty: "Hozircha kartalar yo'q",
    emptyText: "Buyurtmalarni tezroq to'lash uchun karta biriktiring",
    add: "Karta qo'shish",
    cash: 'Naqd pul',
  },

  notifications: {
    title: 'Bildirishnomalar',
    tabNews: 'Yangiliklar',
    tabPromotions: 'Aksiyalar',
    empty: "Bildirishnomalar yo'q",
    emptyText: "Bu yerda Oqtepa Lavash yangiliklari va aksiyalari paydo bo'ladi",
  },

  chat: {
    title: 'Onlayn chat',
    placeholder: 'Xabar',
    closed: 'Chat yopilgan',
    closedHint: "Murojaat yopilgan — bu yerga endi yozib bo'lmaydi",
    call: "Qo'llab-quvvatlashga qo'ng'iroq",
    callConfirm: "Qo'ng'iroq markaziga bog'lanasizmi?",
    attach: "Fayl biriktirish",
    empty: "Hozircha murojaatlar yo'q",
    request: "Qo'llab-quvvatlashga murojaat",
    uploading: "Fayl yuborilmoqda…",
    uploadFailed: "Faylni yuborib bo'lmadi",
    photo: "Foto",
    noticeTitle: "Qo'llab-quvvatlashdan yangi xabar",
    noticeOpen: "Chatni ochish",
    unreadHint: "Qo'llab-quvvatlash javob berdi — chatni oching",
  },

  address: {
    title: 'Mening manzillarim',
    listTitle: 'Yetkazib berish manzillari',
    label: 'Yetkazib berish manzili',
    fallbackLabel: 'Manzil',
    new: 'Yangi manzil',
    edit: 'Manzilni tahrirlash',
    emptyAccent: "Qo'shing",
    emptyTitle: 'birinchi manzilni',
    emptyText: 'Qulay manzilni belgilang — buyurtmani bir necha marta bosib rasmiylashtirasiz.',
    add: "Manzil qo'shish",
    save: 'Manzilni saqlash',
    remove: "Manzilni o'chirish",
    removeConfirm: "Manzil o'chirilsinmi?",
    name: 'Manzil nomi',
    entrance: 'Kirish eshigi',
    floor: 'Qavat',
    flat: 'Xonadon/Ofis',
    entranceShort: 'kirish',
    floorShort: 'qavat',
    flatShort: 'xonadon',
    comment: 'Manzil tafsilotlari',
    detecting: 'Manzil aniqlanmoqda…',
    whereTo: 'Qayerga yetkazamiz?',
    findMe: 'Meni topish',
  },

  branch: {
    title: 'Filialni tanlang',
    where: 'Qayerdan olasiz?',
    search: 'Filial qidirish',
    nearest: "Eng yaqinlarini ko'rsatish",
    notFound: 'Filiallar topilmadi',
    workTime: 'Ish vaqti:',
    workTimeShort: 'Ish vaqti:',
    address: 'Manzil:',
    phone: 'Telefon:',
  },
}

export default uz
